import { Spinner } from "@components/ui-kit";
import { useGetBudgetExceededLazyQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import { getParamFromQuery } from "@src/utils/url";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { CardListBudgetExceeded } from "./CardListBudgetExceeded";
import { StoreBudgetExceeded } from "./StoreBudgetExceeded";

// context holding page related data
export const PageBudgetExceededCtx = React.createContext(
  {} as StoreBudgetExceeded,
);

/**
 * encapsulate initial data fetch & refetch
 */
function useData(store: StoreBudgetExceeded) {
  const [fetchBudgetExceeded, { loading, error }] =
    useGetBudgetExceededLazyQuery({
      onCompleted(data) {
        store.fromGetBudgetExceededQuery(data);
      },
      ...onError(),
    });

  useEffect(() => {
    fetchBudgetExceeded({ variables: store.queryParams });
  }, [store.queryParams]);

  return { loading, error };
}

export const PageBudgetExceeded = withCan(
  { do: ["project_read_own", "project_read_all", "project_read_team"] },
  observer(function PageProjects() {
    const { query } = useRouter();

    const [store] = useState(() => {
      const store = StoreBudgetExceeded.create();
      store.where.fromURLSearchParam(query);
      store.orderBy.fromURLSearchParam(query);
      store.pagination.fromURLSearchParam(query);
      store.setSearchTerm(getParamFromQuery("search", query) ?? "");
      return store;
    });
    useUpdateURI(store.searchParams);

    const { loading } = useData(store);

    return (
      <PageBudgetExceededCtx.Provider value={store}>
        <div className="flex justify-center items-center">
          <div className="w-full">
            {loading && <Spinner absolute />}
            <CardListBudgetExceeded />
          </div>
        </div>
      </PageBudgetExceededCtx.Provider>
    );
  }),
);
